import { LOGIN_FAIL, LOGIN_SUCCESS, LOGOUT, SEND_OTP } from "../action/type";

const initialState = {
  token: localStorage.getItem("token"),
  userId: localStorage.getItem("userId"),
  isAuthenticated: null,
  user: null,
  otp: [],
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case SEND_OTP:
      return { ...state, otp: action.payload };
    case LOGIN_SUCCESS:
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("userId", action.payload.id);
      return { ...state, isAuthenticated: true };
    case LOGIN_FAIL:
    case LOGOUT:
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      return {
        ...state,
        token: null,
        userId: null,
        isAuthenticated: false,
      };
    default:
      return state;
  }
};
export default auth;
